<template>

    <age-gender-chart
        v-if="displayChart"
        :chart-data="ageGenderRanges"
    ></age-gender-chart>

</template>

<script>

import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import AgeGenderChart from "../../Health/components/AgeGenderChart";

export default {

    components: {
        AgeGenderChart
    },

    props: {
        name: {
            type: String,
            required: true
        }
    },

    mounted() {
        this.loadData();
    },

    computed: {
        // Root store
        ...mapState([
            'ageGender',
        ]),

        displayChart() {
            return this.ageGender.length > 0;
        },

        ageGenderRanges() {

            return this.ageGender.map(stat => {
                return {
                    name: stat.name,
                    malePercent: stat.malePercent * -1,
                    femalePercent: stat.femalePercent,
                    maleCount: stat.maleCount,
                    femaleCount: stat.femaleCount,
                }
            });
        }
    },

    methods: {

        // Root store
        ...mapActions([
            'getAgeGender',
        ]),

        loadData(force = false) {

            this.$emit('loading-started');

            this.getAgeGender(force)
                .then(() => {

                    if (!this.displayChart) {
                        this.$emit('insufficient-data', {
                            title: 'No data available',
                        });
                    } else {
                        this.$emit('sufficient-data', true);
                    }

                    this.$emit('loading-ended');
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Age gender statistics failed to load!'});
                    this.$emit('loading-ended');
                });
        }
    },

    created() {
        this.$emit('settings', {title: 'Age vs. Gender', info: 'Panel health', configs: []});

        Bus.$on('refresh-widget-' + this.name, () => {
            this.loadData(true);
        });
    },
}
</script>

<style scoped>
.chart {
    width: 100%;
    height: 325px;
}
</style>
